
    <form [formGroup]="form">
        @if(mode ==="create"){
            <div class="form-group row mb-2">
                <label class="col-form-label col-md-4 text-md-end" for="teamName">{{'teamName' | translate}}</label>
                <div class="col-md-4">
                    <input type="text"
                            id="teamName"
                            name="teamName"
                            formControlName="name"
                            class="form-control"/>
                </div>
                @if (name.invalid && (name.dirty || name.touched)) {
                    @if (name.errors?.['required']) {
                        <div class="text-danger col-md-4 pt-2">{{'error.required' | translate}}</div>
                    }
                    @if (name.errors?.['minlength']) {
                        <div class="text-danger col-md-4 pt-2">{{'error.minLengthTwo' | translate}}</div>
                    }
                }
            </div>
        }
        <div class="form-group row mb-2" formGroupName="notificationTime">
            <label class="col-md-4 col-form-label text-md-end" for="timeZone">{{'timeZone' | translate}}</label>
            <div class="col-md-4">
                <tm-timezone-picker formControlName="timeZone"></tm-timezone-picker>
            </div>
        </div>
    
        <div class="form-group row mb-2 d-flex align-items-center" formGroupName="notificationTime">
            <label class="col-md-4 col-form-label text-md-end">{{'preferedTimeForEmails' | translate}}</label>
            <div class="col-md-4">
                <tm-timepicker formControlName="time"></tm-timepicker>
            </div>
        </div>
    
        @if(team?.moodsDisplayTime){
            <div class="form-group row mb-2 d-flex align-items-center" formGroupName="moodsDisplayTime">
                <label class="col-md-4 col-form-label text-md-end">{{'moodsDisplayTime' | translate}}</label>
                <div class="col-md-4">
                    <tm-timepicker formControlName="time">
                    </tm-timepicker>
                </div>
                <div class="col-md-4">
                    <tm-timezone-picker formControlName="timeZone"></tm-timezone-picker>
                </div>
            </div>
        }
    
        <div class="form-group row mb-2">
            <label class="col-md-4 col-form-label text-md-end" for="workingDays">{{'workingDays' | translate}}</label>
            <div class="col-md-8">
                <tm-working-days formControlName="workingDays" id="workingDays"></tm-working-days>
            </div>
        </div>
    
        <div class="form-group row mb-3">
            <label class="col-md-4 col-form-label text-md-end" for="language">{{'language' | translate}}</label>
            <div class="col-md-4">
                <tm-language-select formControlName="language" id="language"></tm-language-select>
            </div>
        </div>
    </form>

